export let agent = {};
export const initializeGlobalAgent = (newAgent) => {
    agent = newAgent;
    return agent;
};
//# sourceMappingURL=agent.js.map